import "core-js/modules/es.array.map";
import _objectSpread from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
export default {
  props: ['eventId'],
  mixins: [loadMoreList],
  data: function data() {
    return {
      dialogFormVisible: false,
      tableData: [],
      paramsData: {
        // page: 1,
        name: '',
        account: '',
        card_number: '',
        codes: ''
      },
      student_ids: []
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getList(1);

              case 2:
                _this.paramsData = {
                  name: '',
                  account: '',
                  card_number: '',
                  codes: ''
                };

                if (data) {}

                _this.dialogFormVisible = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.student_ids = e;
    },
    getList: function getList(page) {
      var _this2 = this;

      // this.paramsData.page = page;
      if (this.paramsData.account) {
        this.paramsData.appid = process.env.VUE_APP_APPID;
      }

      this.$api.eventParticipantVip(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        event_id: this.eventId
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          _this2.tableData = data; // this.total = res.data.total
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      var ids = this.student_ids.map(function (item) {
        return item.id;
      });
      this.$api.evenParticipantAdd({
        student_ids: ids,
        event_id: this.eventId
      }).then(function (res) {
        if (res.code == 200) {
          _this3.$message.success('添加成功');

          _this3.$emit('change');

          _this3.dialogFormVisible = false;
        } else {
          _this3.$message.error(res.msg);
        }
      });
    }
  }
};